/**
 * Replaces regex matches with an empty tag while streaming, or keeps the original match when complete.
 * Preserves attributes from the source tag so downstream overrides (e.g. dashboard id/title) still work.
 * @param {string} text - Text to process
 * @param {RegExp} regex - Regex pattern to match (capture group 1 = attributes string)
 * @param {string} tagName - Tag name for the empty replacement (e.g., "graph", "dashboard")
 * @param {boolean} complete - Whether the message is complete
 * @returns {string} Processed text
 */
export const replaceTagWhileStreaming = (text, regex, tagName, complete) => {
  return text.replace(regex, (match, attrs) => {
    if (complete) {
      return match;
    }
    const attrStr = attrs ? attrs.trim() : "";
    return attrStr
      ? `<${tagName} ${attrStr}></${tagName}>`
      : `<${tagName}></${tagName}>`;
  });
};
